export default {
  searchText(state) {
    return state.searchText;
  },
  listOptions(state) {
    return state.listOptions;
  },
  stringFilter(state) {
    let filter = '';
    if (state.searchText) {
      filter += `(descricao like '%${state.searchText.toLowerCase()}%' or codigoInterno like '%${state.searchText.toLowerCase()}%')`;
    }
    return filter;
  },
};
